import React, { useState } from "react";
import { adminApi } from "../utils/axiosConfig";
import { motion } from "framer-motion";
import { FaEnvelope, FaLock, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AdminAuth({ onClose }) {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      const res = await adminApi.post('/api/admin/login', formData);

      if (res.data.success) {
        // Stocker le token admin dans localStorage
        localStorage.setItem('adminToken', res.data.token);
        
        setSuccess("Connexion admin réussie !");
        setIsLoggedIn(true);
        setFormData({ email: "", password: "" });
        setTimeout(() => navigate("/admin/dashboard"), 1500);
      } else {
        setError(res.data.message || "Erreur lors de la connexion");
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Erreur réseau ou serveur");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await adminApi.post('/api/admin/logout');
      // Supprimer le token admin du localStorage
      localStorage.removeItem('adminToken');
      setIsLoggedIn(false);
      setSuccess(null);
      setError(null);
      navigate("/admin/login");
    } catch {
      setError("Erreur lors de la déconnexion");
    }
  };

  return (
    <div style={styles.wrapper}>
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={styles.modal}
      >
        {onClose && (
          <button style={styles.closeBtn} onClick={onClose}>
            <FaTimes />
          </button>
        )}

        <h2 style={styles.title}>
          {isLoggedIn ? "Admin connecté" : "Connexion Admin"}
        </h2>

        {!isLoggedIn ? (
          <form onSubmit={handleSubmit}>
            <div style={styles.inputWrapper}>
              <FaEnvelope style={styles.inputIcon} />
              <input
                type="email"
                name="email"
                placeholder="Email admin *"
                value={formData.email}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.inputWrapper}>
              <FaLock style={styles.inputIcon} />
              <input
                type="password"
                name="password"
                placeholder="Mot de passe *"
                value={formData.password}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>

            <motion.button
              type="submit"
              disabled={loading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              style={styles.submitBtn}
            >
              {loading ? "Connexion..." : "Se connecter"}
            </motion.button>
          </form>
        ) : (
          <div>
            <p style={styles.success}>{success}</p>
            <button onClick={handleLogout} style={styles.submitBtn}>
              Déconnexion
            </button>
          </div>
        )}

        {error && <p style={styles.error}>{error}</p>}
      </motion.div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    backdropFilter: "blur(5px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    fontFamily: "Georgia, Utopia, 'Times New Roman', Times, serif",
  },
  modal: {
    backgroundColor: "#fff",
    padding: "50px 40px",
    borderRadius: "10px",
    width: "100%",
    maxWidth: "600px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
    position: "relative",
    textAlign: "center",
  },
  closeBtn: {
    position: "absolute",
    top: 20,
    right: 20,
    fontSize: 24,
    color: "#333",
    cursor: "pointer",
    background: "none",
    border: "none",
    transition: "color 0.2s",
  },
  title: {
    fontSize: "28px",
    fontWeight: "600",
    marginBottom: "30px",
    color: "#000",
  },
  inputWrapper: {
    position: "relative",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
  },
  inputIcon: {
    position: "absolute",
    top: "50%",
    left: 15,
    transform: "translateY(-50%)",
    color: "#999",
  },
  input: {
    width: "90%",
    padding: "12px 15px 12px 40px",
    borderRadius: "6px",
    border: "1px solid #ddd",
    fontSize: "15px",
    transition: "border-color 0.3s",
  },
  submitBtn: {
    width: "100%",
    padding: "14px",
    backgroundColor: "#000",
    color: "#fff",
    fontWeight: "600",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    fontSize: "16px",
    marginTop: "20px",
  },
  error: {
    color: "red",
    marginTop: "15px",
    textAlign: "center",
  },
  success: {
    color: "green",
    marginTop: "15px",
    textAlign: "center",
  },
};
